import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, TextField, Button, MenuItem, Select, FormControl, InputLabel, Snackbar, Alert, Switch, FormControlLabel } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import { apiPatchUser } from '../../../api/user.api';
import { useData } from '../../../hooks';
import TopNavbar from 'examples/Navbars/TopNavbar';

function MemberEdit() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userdata } = location.state || {};
  const { user, appIsReady } = useData();

  const [formData, setFormData] = useState({
    id: userdata?.id || '',
    name: userdata?.name || '',
    userid: userdata?.userid || '',
    email: userdata?.email || '',
    phone: userdata?.phone || '',
    rpoint: userdata?.rpoint || 0,
    oldRpoint: userdata?.oldRpoint || 0,
    mpoint: userdata?.mpoint || 0,
    spoint: userdata?.spoint || 0,
    receivable: userdata?.receivable || 0,
    userType: userdata?.userType || '',
    petcnt: userdata?.petcnt || 0,
    createdAt: userdata?.createdAt || '',
    status: userdata?.status || '',
    // true이면 기프티콘 결제(구매) 차단
    isGiftPurchaseLocked: userdata?.isGiftPurchaseLocked ?? false,
    password: '' // New password field
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue =
      name === 'isGiftPurchaseLocked'
        ? e.target.checked
        : name === 'rpoint' || name === 'mpoint' || name === 'spoint' || name === 'petcnt'
          ? parseInt(value, 10)
          : value;
    setFormData({ ...formData, [name]: newValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const { name, email, phone, rpoint, mpoint, userType, petcnt, status, id, password, spoint, receivable, oldRpoint, isGiftPurchaseLocked } = formData;
    const dataToSend = { name, email, phone, rpoint, mpoint, userType, petcnt, status, password ,spoint, receivable, oldRpoint, isGiftPurchaseLocked };

    try {
      await apiPatchUser(dataToSend, id, user.accessToken);
      setSnackbarMessage('User updated successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setTimeout(() => {
        setIsSubmitting(false);
        navigate(`/members?page=${location.state.page}&searchcond=${location.state.searchcond}`);
      }, 500);
    } catch (error) {
      setSnackbarMessage('Failed to update user.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <DashboardLayout>
      <TopNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                회원정보 수정
              </MDTypography>
            </MDBox>
            <MDBox p={3}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="이름"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="아이디"
                      name="userid"
                      value={formData.userid}
                      onChange={handleInputChange}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="비밀번호"
                      name="password"
                      type="password"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="이메일"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="전화번호"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="R포인트"
                      name="rpoint"
                      type="number"
                      value={formData.rpoint}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="구 R포인트"
                      name="oldRpoint"
                      type="number"
                      value={formData.oldRpoint}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="M포인트"
                      name="mpoint"
                      type="number"
                      value={formData.mpoint}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="S포인트"
                      name="spoint"
                      type="number"
                      value={formData.spoint}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="userType-label">사용자타입</InputLabel>
                      <Select
                        labelId="userType-label"
                        name="userType"
                        value={formData.userType}
                        onChange={handleInputChange}
                        variants='solid'
                        sx={{
                          height: 45,
                        }}
                      >
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="user">User</MenuItem>
                        <MenuItem value="branch">Branch</MenuItem>
                        <MenuItem value="owner">Owner</MenuItem>
                        <MenuItem value="bo">BO</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="userType-label">포인트 수령가능여부</InputLabel>
                      <Select
                        labelId="userType-label"
                        name="receivable"
                        value={formData.receivable}
                        onChange={handleInputChange}
                        variants='solid'
                        sx={{
                          height: 45,
                        }}
                      >
                        <MenuItem value="0">불가</MenuItem>
                        <MenuItem value="1">가능</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="isGiftPurchaseLocked"
                          checked={formData.isGiftPurchaseLocked === true}
                          onChange={handleInputChange}
                          color="info"
                        />
                      }
                      label="기프티콘 결제(구매) 차단"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="누적페트수량"
                      name="petcnt"
                      type="number"
                      value={formData.petcnt}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="가입일"
                      name="createdAt"
                      value={formatDate(formData.createdAt)}
                      onChange={handleInputChange}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="status-label">상태</InputLabel>
                      <Select
                        labelId="status-label"
                        name="status"
                        value={formData.status}
                        onChange={handleInputChange}
                        sx={{
                          height: 45,
                        }}
                      >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="hold">Hold</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <MDBox mt={3} display="flex" justifyContent="flex-end">
                  <Button type="submit" variant="contained" color="success" disabled={isSubmitting}>
                    {isSubmitting ? '저장 중...' : '저장'}
                  </Button>
                </MDBox>
              </form>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default MemberEdit;
